@if (visible) {
  <div class="modal d-block" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="content" [class.error]="isError">
          <div class="inner-content">
            <div class="header">
              <h3 class="title">{{ dialogTitle }}</h3>
              <span class="subtitle">{{ dialogSubtitle }}</span>
            </div>
          </div>
          <div class="btn-row">
            <button
              type="button"
              class="new-btn secondary-btn"
              (click)="onClick()"
              >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
